import { DepartmentPropertyComponent } from "./department-property";
import { DetailsMainComponent } from "./details-main.component";
import { ProgramPropertyComponent } from "./program-property";
import { ProjectPropertyComponent } from "./project-property";
import { RoomContentPropertyComponent } from "./room-content-property";
import { RoomPropertyComponent } from "./room-property";

export * from "./details-main.component";
export * from "./room-property";
export * from "./department-property";
export * from "./program-property";
export * from "./project-property";
export * from "./room-content-property";


export const DetailPages = [
  DetailsMainComponent,
  RoomPropertyComponent,
  DepartmentPropertyComponent,
  ProgramPropertyComponent,
  ProjectPropertyComponent,
  RoomContentPropertyComponent
];
